export default __webpack_public_path__ + "static/04-8877922e6ae5276852fa90430d407a90.png";